import {useTranslation} from 'react-i18next';
import config from '../../../../../app/config';
import React, {useEffect} from 'react';
import _ from 'lodash';
import moment from 'moment/moment';
import * as _debounce from 'lodash/debounce';
import div from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import {emitChangedWait, obsStatuses, obsTypes} from '../obsUtils';
import renderAcceptSection from './renderAcceptSection';
import AgyleBlockSwitch from '../../../../../components/ui/switch/agyleBlockSwitch';
import {obsStyles} from '../obsStyle';

function ObsStridor(props) {
    const classes = obsStyles();
    const {t} = useTranslation();
    const {type, ageRangeYears} = props;
    const allowDefaultValue = config?.observations?.defaultValues;
    const disableAcceptButtons = config?.observations?.disableAcceptButtons;

    const [status, setStatus] = React.useState(props.status || obsStatuses.new);
    const [stridor, setStridor] = React.useState(allowDefaultValue ? props.stridor : null);
    const [score, setScore] = React.useState(props.score);
    const [accepted, setAccepted] = React.useState(props.accepted);
    const [acceptDate, setAcceptDate] = React.useState(props.acceptDate);

    function setDefaults() {
        setStridor(false);
    }

    // For Mobile view
    useEffect(() => {
        if (props.ipodView && props.status !== obsStatuses.new) {
            setStridor(props.stridor);
        }
    }, []);

    useEffect(() => {
        if ((_.isUndefined(stridor) || _.isNull(stridor)) && allowDefaultValue) {
            if (_.isUndefined(props.stridor) || _.isNull(props.stridor)) {
                setDefaults();
            } else {
                setStridor(props.stridor);
            }
        }
    }, [props.stridor]);

    const clearAccepted = () => {
        setStatus(obsStatuses.new);
        setAccepted(false);
        setAcceptDate(null);
    };

    const resetObs = () => {
        if (!allowDefaultValue) {
            setStridor(null);
        } else {
            setDefaults();
        }

        clearAccepted();
    };

    const acceptObs = () => {
        if (status === obsStatuses.new) {
            setStatus(obsStatuses.completed);
        }
        setAcceptDate(moment());
        setAccepted(true);
    };

    useEffect(() => {
        const checkValue = (!_.isNull(stridor) && status === obsStatuses.new)
            || (status !== obsStatuses.completed && status !== obsStatuses.new);

        if (disableAcceptButtons && checkValue) {
            acceptObs();
        }
    }, [stridor, status]);

    const lazyEmitOnChange = React.useMemo(() => {
        return _debounce((value, onChange) => {
            // console.log("lazyEmitOnChange", value);
            onChange(value);
        }, emitChangedWait);
    }, []);

    const emitChanged = () => {
        if (props.onChange) {
            // console.log("emitChanged");
            lazyEmitOnChange(
                {
                    status,
                    stridor,
                    score,
                    accepted,
                    acceptDate,
                },
                props.onChange,
            );
        }
    };

    useEffect(() => {
        emitChanged();
    }, [status, stridor, score, accepted, acceptDate]);

    // const updateScore = () => {
    //     let newScore = 0;
    //     if (status === obsStatuses.notRecorded || status === obsStatuses.patientRefused || status === obsStatuses.equipment) {
    //         newScore = 0;
    //     } else if (status === obsStatuses.patientCondition) {
    //         newScore = 3;
    //     } else {
    //         if (stridor) {
    //             newScore = stridor.score;
    //         }
    //     }
    //     setScore(newScore);
    // };
    // useEffect(() => {
    //     updateScore();
    // }, [status, stridor]);

    const onStridorChange = (value) => {
        setStridor(value);
        clearAccepted();
    };

    const onStatusChange = (value) => {
        clearAccepted();
        if (value && value !== status) {
            setStatus(value);
        }
    };

    return (
        <div className={classes.obsRoot}>
            <div className={classes.obsContent}>
                <Grid container alignItems={'center'} spacing={2}>
                    <Grid item xs={6}>
                        <AgyleBlockSwitch
                            onChange={value => onStridorChange(value)}
                            value={stridor}
                            customLabels={{
                                no: t('No'),
                                yes: t('Yes'),
                            }}
                        />
                    </Grid>

                    {renderAcceptSection({
                        classes,
                        t,
                        hideScore: true,
                        score,
                        status,
                        onStatusChange,
                        resetObs,
                        accepted,
                        acceptObs,
                        acceptDate,
                        acceptDisabled: _.isNull(stridor),
                        showStatusNR: type === obsTypes.pews,
                        disableAcceptButtons,
                    })}
                </Grid>
            </div>
        </div>
    );
}

ObsStridor.propTypes = {
    type: PropTypes.oneOf([
        obsTypes.news,
        obsTypes.pews,
        obsTypes.neuro,
    ]),
    ageRangeYears: PropTypes.string,
    status: PropTypes.string,
    score: PropTypes.number,
    stridor: PropTypes.oneOf([null, false, true]),
    accepted: PropTypes.bool,
    acceptDate: PropTypes.instanceOf(moment),
    onChange: PropTypes.func,
};
ObsStridor.defaultProps = {
    type: obsTypes.news,
    status: obsStatuses.new,
    score: 0,
    accepted: false,
    acceptDate: null,
};

export default React.memo(ObsStridor);